import React, { useRef } from 'react';
import { Box, Divider } from '@mui/material';
import {
  FormProps,
  FormHeader,
  ClientNameField,
  DocumentUploadArea,
  FactsDescriptionField,
  PieceToRebutField,
  AudioRecordingSection,
  WritingStyleSelector,
  InfoTip,
} from './shared';

// Opções para contrarrazões ao recurso extraordinário
const PECAS_REFERENCIA = [
  'Recurso Extraordinário',
  'Acórdão',
  'Processo Inteiro',
  'Outro'
];

const ContrarrazoesREForm: React.FC<FormProps> = ({
  documentType,
  values,
  onChange,
  uploadedFiles,
  onFileUpload,
  onFileRemove,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedStyle, setSelectedStyle] = React.useState(values.estilo_escrita || 'padrao');

  const handleFieldChange = (fieldId: string, value: any) => {
    onChange({
      ...values,
      [fieldId]: value,
    });
  };

  const handleRecordingComplete = (audioBlob: Blob) => {
    const audioFile = new File([audioBlob], `audio_${Date.now()}.webm`, {
      type: 'audio/webm',
    });
    onFileUpload([audioFile]);
  };

  return (
    <Box>
      <FormHeader 
        documentType={documentType}
        customTitle="Contrarrazões ao Recurso Extraordinário"
        customDescription="Resposta ao recurso extraordinário interposto pela parte contrária perante o STF"
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* 1. Nome do Cliente */}
        <ClientNameField
          value={values.nome_cliente || ''}
          onChange={(value) => handleFieldChange('nome_cliente', value)}
        />

        {/* 2. Upload de Documentos */}
        <DocumentUploadArea
          uploadedFiles={uploadedFiles}
          onFileUpload={onFileUpload}
          onFileRemove={onFileRemove}
          suggestedDocs="Acórdão, Processo na íntegra e RE."
          fileInputRef={fileInputRef as React.RefObject<HTMLInputElement>}
        />

        {/* 3. Descrição dos Fatos (Opcional) */}
        <FactsDescriptionField
          value={values.fatos_caso || ''}
          onChange={(value) => handleFieldChange('fatos_caso', value)}
          placeholder="Descreva argumentos adicionais para refutar o recurso extraordinário da parte contrária..."
        />

        {/* 4. Peça de referência */}
        <PieceToRebutField
          value={values.peca_rebater || 'Recurso Extraordinário'}
          onChange={(value) => handleFieldChange('peca_rebater', value)}
          otherValue={values.peca_rebater_outro || ''}
          onOtherChange={(value) => handleFieldChange('peca_rebater_outro', value)}
          options={PECAS_REFERENCIA}
          label="Indique a peça do processo que deseja rebater ou responder:"
        />

        {/* Gravação de Áudio */}
        <AudioRecordingSection
          onRecordingComplete={handleRecordingComplete}
          description="Grave um áudio descrevendo os argumentos de defesa que a IA irá transcrever automaticamente."
        />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Estilo de Escrita */}
      <WritingStyleSelector
        selectedStyle={selectedStyle}
        onStyleChange={(styleId) => {
          setSelectedStyle(styleId);
          handleFieldChange('estilo_escrita', styleId);
        }}
      />

      <InfoTip message="Anexe o RE da parte contrária e o acórdão recorrido. As contrarrazões devem demonstrar a ausência de violação constitucional, a falta de prequestionamento ou a ausência de repercussão geral da matéria." />
    </Box>
  );
};

export default ContrarrazoesREForm;

